

const Anomalies = () => {
  return (
    <div>Anomalies</div>
  )
}

export default Anomalies